module.exports = __webpack_public_path__ + "files/9c021266b072858b441ab6247d99b48d.png";